module.exports = __webpack_public_path__ + "assets/aac419c21d93abf21f4ecfbcb3daf62a.png";